import React from 'react';
import BaseLink from './Link';
import {Link as RouterLink} from 'react-router-dom'

export default React.forwardRef ((props, ref) => <BaseLink color={"secondary"} {...props} component={RouterLink} ref={ref} />);